<template>
  <div class="corner-wrap">
    <span class="corner-basic lt-corner"></span>
    <span class="corner-basic rt-corner"></span>
    <span class="corner-basic lb-corner"></span>
    <span class="corner-basic rb-corner"></span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "cornerBox"
};
</script>

<style scoped lang="scss">
.corner-wrap {
  position: relative;
  .corner-basic {
    position: absolute;
    width: 15px;
    height: 15px;
    &.lt-corner {
      left: -4px;
      top: -4px;
      background: url("../assets/images/main/l_t_corner.png") no-repeat;
    }
    &.rt-corner {
      right: -4px;
      top: -4px;
      background: url("../assets/images/main/r_t_corner.png") no-repeat;
    }
    &.lb-corner {
      left: -4px;
      bottom: -4px;
      background: url("../assets/images/main/l_b_corner.png") no-repeat;
    }
    &.rb-corner {
      right: -4px;
      bottom: -4px;
      background: url("../assets/images/main/r_b_corner.png") no-repeat;
    }
  }
}
</style>
